// Contenedor de toasts. Se monta una sola vez en HomeView/App y escucha
// al bus toast-bus para mostrar cada mensaje durante el tiempo indicado
// (3 s por defecto).

import { html } from 'htm/preact'
import { useEffect, useState } from 'preact/hooks'

import { onToast } from '../lib/toast-bus.js'

let nextId = 1

export function ToastContainer() {
  const [toasts, setToasts] = useState([])

  useEffect(() => {
    return onToast((detail) => {
      const id = nextId++
      const duration = detail.duration ?? 3000
      setToasts((prev) => [...prev, { id, ...detail }])
      window.setTimeout(() => {
        setToasts((prev) => prev.filter((t) => t.id !== id))
      }, duration)
    })
  }, [])

  if (toasts.length === 0) return null

  return html`
    <div
      class="toast-container"
      role="status"
      aria-live="polite"
      aria-atomic="false"
    >
      ${toasts.map(
        (t) => html`
          <div
            key=${t.id}
            class=${`toast toast--${t.kind || 'info'}`}
          >
            ${t.message}
          </div>
        `
      )}
    </div>
  `
}
